import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import useEntity from '@/recoil/useEntity/useEntity.ts'
import organizationsAtom from '@/pages/Organizations/organizations.atom.ts'
import organizationsApi from '@/pages/Organizations/organizations.api.ts'

const useOrganization = (id: IOrganization['id']) => {
  const { entity } = useEntity<IOrganization>({
    entityId: id,
    atom: organizationsAtom,
    itemFetcher: organizationsApi.getOne,
  })

  return { organization: entity }
}

export default useOrganization
